<template>
  <div class="container">
    <div v-if="!isMobile">
      <table>
        <thead>
          <tr>
            <th>Account</th>
            <th v-for="(item, index) in visiblePeriodDate" v-bind:key="index">
              {{ item != undefined && item.isValid != undefined && item.isValid() ? item.format("DD-MMM-YYYY") : item }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>Revenue</th>
            <td v-for="(item, index) in revenueSliced" v-bind:key="index">
              {{ vueNumberFormat(parseFloat(item), { precision: 2 }) }}
            </td>
          </tr>
          <tr>
            <th>Gross Profit</th>
            <td v-for="(item, index) in grossProfitSliced" v-bind:key="index">
              {{ vueNumberFormat(parseFloat(item), { precision: 2 }) }}
            </td>
          </tr>
          <tr>
            <th>EBITDA</th>
            <td v-for="(item, index) in ebitdaSliced" v-bind:key="index">
              {{ vueNumberFormat(parseFloat(item), { precision: 2 }) }}
            </td>
          </tr>
          <tr>
            <th>EBIT</th>
            <td v-for="(item, index) in ebitSliced" v-bind:key="index">
              {{ vueNumberFormat(parseFloat(item), { precision: 2 }) }}
            </td>
          </tr>
          <tr>
            <th>Earning from Cont. Ops.</th>
            <td v-for="(item, index) in earningCoSliced" v-bind:key="index">
              {{ vueNumberFormat(parseFloat(item), { precision: 2 }) }}
            </td>
          </tr>
          <tr>
            <th>Net Income</th>
            <td v-for="(item, index) in netIncomeSliced" v-bind:key="index">
              {{ vueNumberFormat(parseFloat(item), { precision: 2 }) }}
            </td>
          </tr>
          <tr>
            <th>Diluted EPS Excl. Extra Items</th>
            <td v-for="(item, index) in dilutedEpsSliced" v-bind:key="index">
              {{ vueNumberFormat(parseFloat(item), { precision: 2 }) }}
            </td>
          </tr>
          <tr>
            <th>Filing Date</th>
            <td v-for="(item, index) in filingDateSliced" v-bind:key="index">
              {{ item != undefined && item.isValid() ? item.format("DD-MMM-YYYY") : "" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="fin-list">
      <div class="fin-card">
        <div class="fin-title">Revenue</div>
        <div class="fin-row" v-for="(val, idx) in revenueSliced" :key="idx"><span class="period">{{ visiblePeriodDate[idx] != undefined && visiblePeriodDate[idx].isValid ? visiblePeriodDate[idx].format('DD-MMM-YYYY') : visiblePeriodDate[idx] }}</span><span class="val right">{{ vueNumberFormat(parseFloat(val), { precision: 2 }) }}</span></div>
      </div>

      <div class="fin-card">
        <div class="fin-title">Gross Profit</div>
        <div class="fin-row" v-for="(val, idx) in grossProfitSliced" :key="idx"><span class="period">{{ visiblePeriodDate[idx] != undefined && visiblePeriodDate[idx].isValid ? visiblePeriodDate[idx].format('DD-MMM-YYYY') : visiblePeriodDate[idx] }}</span><span class="val right">{{ vueNumberFormat(parseFloat(val), { precision: 2 }) }}</span></div>
      </div>

      <div class="fin-card">
        <div class="fin-title">EBITDA</div>
        <div class="fin-row" v-for="(val, idx) in ebitdaSliced" :key="idx"><span class="period">{{ visiblePeriodDate[idx] != undefined && visiblePeriodDate[idx].isValid ? visiblePeriodDate[idx].format('DD-MMM-YYYY') : visiblePeriodDate[idx] }}</span><span class="val right">{{ vueNumberFormat(parseFloat(val), { precision: 2 }) }}</span></div>
      </div>

      <div class="fin-card">
        <div class="fin-title">EBIT</div>
        <div class="fin-row" v-for="(val, idx) in ebitSliced" :key="idx"><span class="period">{{ visiblePeriodDate[idx] != undefined && visiblePeriodDate[idx].isValid ? visiblePeriodDate[idx].format('DD-MMM-YYYY') : visiblePeriodDate[idx] }}</span><span class="val right">{{ vueNumberFormat(parseFloat(val), { precision: 2 }) }}</span></div>
      </div>

      <div class="fin-card">
        <div class="fin-title">Earning from Cont. Ops.</div>
        <div class="fin-row" v-for="(val, idx) in earningCoSliced" :key="idx"><span class="period">{{ visiblePeriodDate[idx] != undefined && visiblePeriodDate[idx].isValid ? visiblePeriodDate[idx].format('DD-MMM-YYYY') : visiblePeriodDate[idx] }}</span><span class="val right">{{ vueNumberFormat(parseFloat(val), { precision: 2 }) }}</span></div>
      </div>

      <div class="fin-card">
        <div class="fin-title">Net Income</div>
        <div class="fin-row" v-for="(val, idx) in netIncomeSliced" :key="idx"><span class="period">{{ visiblePeriodDate[idx] != undefined && visiblePeriodDate[idx].isValid ? visiblePeriodDate[idx].format('DD-MMM-YYYY') : visiblePeriodDate[idx] }}</span><span class="val right">{{ vueNumberFormat(parseFloat(val), { precision: 2 }) }}</span></div>
      </div>

      <div class="fin-card">
        <div class="fin-title">Diluted EPS Excl. Extra Items</div>
        <div class="fin-row" v-for="(val, idx) in dilutedEpsSliced" :key="idx"><span class="period">{{ visiblePeriodDate[idx] != undefined && visiblePeriodDate[idx].isValid ? visiblePeriodDate[idx].format('DD-MMM-YYYY') : visiblePeriodDate[idx] }}</span><span class="val right">{{ vueNumberFormat(parseFloat(val), { precision: 2 }) }}</span></div>
      </div>

    </div>
  </div>
</template>
<script>
  const jp = require('jsonpath');
  const moment = require('moment');
  import api from '@/api/dashboard1.js';

export default {
  name: "Financials",
  data: () => {
    return {
      revenue: new Array(6),
      grossProfit: new Array(6),
      ebitda: new Array(6),
      ebit: new Array(6),
      earningCo: new Array(6),
      netIncome: new Array(6),
      dilutedEps: new Array(6),
      filingDate: new Array(6),
      periodDate: [
        "IQ_FY-5",
        "IQ_FY-4",
        "IQ_FY-3",
        "IQ_FY-2",
        "IQ_FY-1",
        "IQ_FY",
      ]
    }
  },
  computed: {
    isMobile(){ return (typeof window !== 'undefined' && window.innerWidth <= 768) },
    visibleColumns(){ return this.isMobile ? Math.min(5, this.periodDate.length) : this.periodDate.length },
    visiblePeriodDate(){ return this.periodDate.slice(-this.visibleColumns) },
    revenueSliced(){ return (this.revenue||[]).slice(-this.visibleColumns) },
    grossProfitSliced(){ return (this.grossProfit||[]).slice(-this.visibleColumns) },
    ebitdaSliced(){ return (this.ebitda||[]).slice(-this.visibleColumns) },
    ebitSliced(){ return (this.ebit||[]).slice(-this.visibleColumns) },
    earningCoSliced(){ return (this.earningCo||[]).slice(-this.visibleColumns) },
    netIncomeSliced(){ return (this.netIncome||[]).slice(-this.visibleColumns) },
    dilutedEpsSliced(){ return (this.dilutedEps||[]).slice(-this.visibleColumns) },
    filingDateSliced(){ return (this.filingDate||[]).slice(-this.visibleColumns) }
  },
  methods: {
    render: async function (q) {
      const r = await api.fetchFinancial(q);
      this.revenue = jp.query(r, "GDSSDKResponse[0]..Row[0]");
      this.grossProfit = jp.query(r, "GDSSDKResponse[1]..Row[0]");
      this.ebitda = jp.query(r, "GDSSDKResponse[2]..Row[0]");
      this.ebit = jp.query(r, "GDSSDKResponse[3]..Row[0]");
      this.earningCo = jp.query(r, "GDSSDKResponse[4]..Row[0]");
      this.netIncome = jp.query(r, "GDSSDKResponse[5]..Row[0]");
      this.dilutedEps = jp.query(r, "GDSSDKResponse[6]..Row[0]");
      this.filingDate = jp.query(r, "GDSSDKResponse[7]..Row[0]").map((x) => moment(x, "MM/DD/YYYY h:mm:ss A"));
      this.periodDate = jp.query(r, "GDSSDKResponse[8]..Row[1]").map((x) => moment(x, "MM/DD/YYYY"));
    }
  }
};
</script>
<style scoped>
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

  .container table {
    width: 100%;
    border-collapse: collapse;
    border-radius: 5px;
    overflow: hidden;
  }

  .container td,
  th {
    padding: 10px;
    background-color: #fafafa;
    text-align: left;
    border: 2px solid #ddd;
  }

  .container td {
    text-align: right;
  }

  .container thead th {
    text-align: center;
  }

  .container td {
    background-color: #fefefe;
  }

  .container tbody th {
    width: 28%;
  }

.container tbody td {
  width: 12%;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .container { width: 100%; padding: 6px }
  .container tbody th, .container tbody td { width: auto; padding: 8px; font-size:13px }
  .container thead th { font-size:13px }

  /* Mobile stacked cards for financials */
  .fin-list { display:flex; flex-direction:column; gap:10px }
  .fin-card { padding:10px; border-radius:6px; background:#fff; box-shadow:0 0 0 1px #eee }
  .fin-title { font-weight:600; margin-bottom:6px }
  .fin-row { display:flex; justify-content:space-between; gap:12px; padding:6px 0 }
  .fin-row .period{ color:#666; font-size:12px }
  .fin-row .val { font-size:14px }
}
</style>
